import React from 'react';
import Checkbox from '../inputs/Checkbox';

type DairenCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

const DairenCheckbox: React.FC<DairenCheckboxProps> = ({
  checked,
  onChange,
  className,
}) => {
  return (
    <Checkbox
      label="大連"
      checked={checked}
      onChange={onChange}
      className={className}
    />
  );
};

export default DairenCheckbox;
